package com.essntl.features.client.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.BasicAlertDialog
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.DialogProperties
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.client.ui.addeditclient.AddEditClientEvent
import com.essntl.features.client.ui.addeditclient.AddEditClientScreen
import com.essntl.features.client.ui.addeditclient.AddEditClientState
import com.essntl.features.client.ui.addeditclient.AddEditClientValidation
import com.essntl.uikit.components.iconbutton.outline.EsSmallOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun AddEditClientDialog(
    onDismissRequest: () -> Unit,
    currentClient: ClientModel? = null,
    state: AddEditClientState,
    validation: AddEditClientValidation,
    onEvent: (AddEditClientEvent) -> Unit,
    openDialog: Boolean,
    modifier: Modifier = Modifier,
) {

    LaunchedEffect(openDialog) {
        if (openDialog) {
            onEvent(AddEditClientEvent.ClearClientState)
            if (currentClient != null)
                onEvent(AddEditClientEvent.GetClient(currentClient.id))
        }
    }

    if (openDialog) {
        BasicAlertDialog(
            onDismissRequest = onDismissRequest,
            properties = DialogProperties(
                usePlatformDefaultWidth = false,
            ),
            modifier = modifier.fillMaxSize(0.7f),
        ) {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(25.dp)),
            ) {
                Column(
                    horizontalAlignment = Alignment.Start,
                    verticalArrangement = Arrangement.Center,
                    modifier = Modifier
                        .fillMaxWidth()
                        .background(color = Color.White),
                ) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .background(color = MaterialTheme.esColorScheme.bgPrimary)
                            .padding(vertical = 3.spacing, horizontal = 2.5.spacing),
                    ) {
                        Text(
                            text = if (currentClient != null) "Edit" else "New traveller",
                            style = MaterialTheme.esTypography.h3Bold24,
                            color = MaterialTheme.esColorScheme.textPrimary,
                            modifier = Modifier.align(Alignment.CenterStart),
                        )

                        EsSmallOutlineIconButton(
                            onClick = {
                                onDismissRequest()
                            },
                            iconRes = EsIcons.Close,
                            modifier = Modifier.align(Alignment.CenterEnd),
                        )
                    }

                    AddEditClientScreen(
                        state = state,
                        validation = validation,
                        onEvent = onEvent,
                        dialog = true,
                    )
                }
            }
        }
    }
}